import React from 'react';
import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/styled-button';
import { StaticImage } from 'gatsby-plugin-image';

const PromoCalldrip = ({ className }) => (
  <div className={className}>
    <Wrapper>
      <Inner>
        <ImageWrapper>
          <StaticImage
            src="../../images/phone.png"
            placeholder="none"
            layout="constrained"
            width={400}
            loading="eager"
            alt="Phone"
          />
        </ImageWrapper>
        <SvgWrapper>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 414 106" fill="none">
            <path d="M130.725 1.4434C132.112 1.4434 133.083 1.85768 133.638 2.68622C134.193 3.51476 134.285 4.52743 133.916 5.72422L105.614 101.007C104.966 102.94 103.579 103.907 101.452 103.907H86.4683C84.1561 103.907 82.7225 102.94 82.1675 101.007L64.6871 40.6611C64.5021 39.8326 64.2246 39.4183 63.8546 39.4183C63.5772 39.3262 63.2997 39.8326 63.0222 40.9373L45.403 101.007C44.8481 102.94 43.4607 103.907 41.2409 103.907H25.8414C23.6217 103.907 22.188 102.94 21.5406 101.007L-6.76116 5.72422C-7.03863 4.52743 -6.89993 3.51476 -6.34499 2.68622C-5.79005 1.85768 -4.81888 1.4434 -3.43153 1.4434H13.9103C15.1126 1.4434 15.945 1.67355 16.4075 2.13385C16.9624 2.5021 17.3323 3.05446 17.5173 3.79094L35.4141 66.6221C35.6916 67.6348 35.969 68.1411 36.2465 68.1411C36.5239 68.1411 36.8014 67.7729 37.0789 67.0364L54.9756 3.79094C55.1606 3.05446 55.4843 2.5021 55.9468 2.13385C56.5017 1.67355 57.3804 1.4434 58.5827 1.4434H73.4273C74.6297 1.4434 75.4621 1.67355 75.9245 2.13385C76.4795 2.5021 76.8957 3.05446 77.1731 3.79094L95.3474 67.5888C95.5323 68.2332 95.8097 68.6014 96.1797 68.6935C96.5497 68.6935 96.7809 68.3713 96.8734 67.7269L114.493 3.79094C114.678 3.05446 115.048 2.5021 115.603 2.13385C116.157 1.67355 117.036 1.4434 118.238 1.4434H130.725Z" fill="white" fillOpacity="0.2" />
            <path d="M186.095 105.287C176.291 105.287 167.828 103.216 160.706 99.0734C153.585 94.8386 148.082 88.8087 144.197 80.9836C140.405 73.1584 138.509 63.8603 138.509 53.0893C138.509 42.1341 140.451 32.6979 144.336 24.7807C148.313 16.8635 153.862 10.7875 160.984 6.55275C168.106 2.22592 176.476 0.0625 186.095 0.0625C195.714 0.0625 204.038 2.22592 211.067 6.55275C218.189 10.7875 223.692 16.8635 227.576 24.7807C231.461 32.6058 233.403 41.996 233.403 52.9512C233.403 63.7222 231.461 73.0203 227.576 80.8455C223.784 88.6706 218.327 94.7006 211.206 98.9353C204.084 103.17 195.714 105.287 186.095 105.287ZM186.095 88.3024C193.679 88.3024 199.228 85.5866 202.743 80.155C206.258 74.6314 208.015 65.6555 208.015 53.2274C208.015 40.523 206.211 31.317 202.604 25.6092C199.09 19.8094 193.586 16.9095 186.095 16.9095C178.511 16.9095 172.915 19.8094 169.308 25.6092C165.701 31.4091 163.897 40.6151 163.897 53.2274C163.897 65.5635 165.655 74.4933 169.169 80.0169C172.776 85.5406 178.418 88.3024 186.095 88.3024Z" fill="white" fillOpacity="0.2" />
            <path d="M375.542 1.4434C376.929 1.4434 377.901 1.85768 378.455 2.68622C379.01 3.51476 379.103 4.52743 378.733 5.72422L350.431 101.007C349.784 102.94 348.396 103.907 346.269 103.907H331.286C328.974 103.907 327.54 102.94 326.985 101.007L309.505 40.6611C309.32 39.8326 309.042 39.4183 308.672 39.4183C308.395 39.3262 308.117 39.8326 307.84 40.9373L290.22 101.007C289.666 102.94 288.278 103.907 286.058 103.907H270.659C268.439 103.907 267.005 102.94 266.358 101.007L238.056 5.72422C237.779 4.52743 237.918 3.51476 238.472 2.68622C239.027 1.85768 239.999 1.4434 241.386 1.4434H258.728C259.93 1.4434 260.762 1.67355 261.225 2.13385C261.78 2.5021 262.15 3.05446 262.335 3.79094L280.232 66.6221C280.509 67.6348 280.786 68.1411 281.064 68.1411C281.341 68.1411 281.619 67.7729 281.896 67.0364L299.793 3.79094C299.978 3.05446 300.302 2.5021 300.764 2.13385C301.319 1.67355 302.198 1.4434 303.4 1.4434H318.245C319.447 1.4434 320.28 1.67355 320.742 2.13385C321.297 2.5021 321.713 3.05446 321.991 3.79094L340.165 67.5888C340.35 68.2332 340.627 68.6014 340.997 68.6935C341.367 68.6935 341.598 68.3713 341.691 67.7269L359.31 3.79094C359.495 3.05446 359.865 2.5021 360.42 2.13385C360.975 1.67355 361.854 1.4434 363.056 1.4434H375.542Z" fill="white" fillOpacity="0.2" />
            <path d="M413.276 100.592C413.276 102.802 412.027 103.907 409.53 103.907H393.159C391.124 103.907 390.107 102.94 390.107 101.007V83.8835C390.107 82.2264 390.801 81.3978 392.188 81.3978H411.195C412.582 81.3978 413.276 82.1343 413.276 83.6073V100.592ZM408.836 68.8316C408.744 69.9363 408.42 70.7188 407.865 71.1791C407.31 71.6394 406.385 71.8696 405.09 71.8696H397.737C396.628 71.8696 395.888 71.6855 395.518 71.3172C395.24 70.8569 395.009 70.1204 394.824 69.1078L389.552 3.92904C389.46 3.10049 389.598 2.5021 389.968 2.13385C390.431 1.67355 390.986 1.4434 391.633 1.4434H412.027C413.507 1.4434 414.154 2.22592 413.969 3.79094L408.836 68.8316Z" fill="white" fillOpacity="0.2" />
          </svg>
        </SvgWrapper>
        <Title>WOW! Bel je klanten automatisch binnen 30 seconden met Calldrip!</Title>
        <StyledButton $secondary to="/calldrip/">Direct ervaren</StyledButton>
      </Inner>
    </Wrapper>
  </div>
);

const ImageWrapper = styled.div`
  position: absolute;
  left: 0;
  top: -8rem;
  z-index: 2;
`;

const StyledButton = styled(Button)`
  font-weight: 700;
`;

const Title = styled.div`
  text-align: center;
  font-weight: 700;
  color: white;
  line-height: 150%;
  padding: 1rem;
`;

const SvgWrapper = styled.div`
  overflow: hidden;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: ${({ theme }) => theme.secondaryColor};
  border-radius: 50%;
  aspect-ratio: 1 / 1;
  height: 100%;
  width: auto;
  max-width: 25rem;

  svg {
    width: 100%;
    height: auto;
  }
`;

const Wrapper = styled.div`
  margin: 8rem auto 0 auto;
  
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    margin: 0 0 0 auto;
  }
`;

export default styled(PromoCalldrip)`
  display: flex;
  grid-column: span 12;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    grid-column: span 6;
  }
`;
